import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentIframeActionsService } from '@shared/modules/comments/services/comment-iframe-actions/comment-iframe-actions.service';

@NgModule({
  imports: [CommonModule]
})
export class CommentIframeActionsModule {
  static forRoot(): ModuleWithProviders<CommentIframeActionsModule> {
    return {
      ngModule: CommentIframeActionsModule,
      providers: [CommentIframeActionsService]
    };
  }
}
